// @ts-nocheck
import React, { useState } from "react";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import { useDispatch } from "react-redux";
import { createCareer } from "../../../features/career";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const AddCareer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    role_title: "",
    role: "",
    location: "",
    employment_type: "", 
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    console.log(formData, "formData");
    dispatch(createCareer(formData))
      .then((res) => {
        toast.success(res.payload.message || "Career created successfully.");
        navigate("/career");
      })
      .catch((err) => {
        console.error(err, "error");
        toast.error("Failed to create career.");
      });
  };

  return (
    <SoftBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bgColor="white"
      shadow="lg"
      borderRadius="lg"
      p={4}
    >
      <SoftBox width="100%" maxWidth="400px">
        <SoftBox mb={2}>
          <SoftTypography variant="h4" fontWeight="bold" textAlign="center">
            Add Career
          </SoftTypography>
        </SoftBox>
        <SoftBox component="form" role="form">
          {/* Role Title Input */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Role Title
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="role_title"
              placeholder="Enter the role title"
              value={formData.role_title}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Role Input */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Role
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="role"
              placeholder="Enter the role"
              value={formData.role}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Location Input */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Location
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="location"
              placeholder="Enter the location"
              value={formData.location}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Employment Type Dropdown */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Employment Type
              </SoftTypography>
            </SoftBox>
      
            <SoftInput
              type="text"
              name="employment_type"
              placeholder="Enter the employment type"
              value={formData.employment_type}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Submit Button */}
          <SoftBox mt={4} mb={1}>
            <SoftButton variant="gradient" color="final" fullWidth onClick={handleSubmit}>
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default AddCareer;
